export default {
  UPDATE_LOCATORS: 'UPDATE_LOCATORS',
  UPDATE_MACHINE_DATA: 'UPDATE_MACHINE_DATA',
  UPDATE_LOCATOR_FILTER: 'UPDATE_LOCATOR_FILTER',
  UPDATE_HIGHLIGHTED_MACHINE: 'UPDATE_HIGHLIGHTED_MACHINE',
  UPDATE_OPEN_MACHINE: 'UPDATE_OPEN_MACHINE',
  UPDATE_OPEN_MACHINE_SELECTED_JOB: 'UPDATE_OPEN_MACHINE_SELECTED_JOB',
  UPDATE_INSERT_JOB_TYPE: 'UPDATE_INSERT_JOB_TYPE',
  UPDATE_LOCATION_DATA: 'UPDATE_LOCATION_DATA',
  UPDATE_NOTES_MODAL_CB: 'UPDATE_NOTES_MODAL_CB',
  UPDATE_NOTES_INIT_VALUE: 'UPDATE_NOTES_INIT_VALUE',
  UPDATE_TIMELINE_VIEW_TYPE: 'UPDATE_TIMELINE_VIEW_TYPE',
  UPDATE_TIMELINE_TEXT_FILTER: 'UPDATE_TIMELINE_TEXT_FILTER',
  UPDATE_WEEK_FILTER: 'UPDATE_WEEK_FILTER',
};